import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import {
  hasAnyPermission,
  hasPermission,
  type PermissionsWithScope,
} from 'src/react-app/lib/permissions'

interface PrivateRouteProps {
  session: any
  allowedPermissions?: string[]
}

export const PrivateRoute = ({ session, allowedPermissions }: PrivateRouteProps) => {
  const location = useLocation()
  const pws = session?.sessionData?.permissionsWithScope
  const hasRoles = Boolean(session?.sessionData?.roles?.length)
  const isAuthorizedSession = Boolean(
    session?.sessionData &&
      session?.sessionData?.user &&
      session?.sessionData?.user['id'] > 0 &&
      (hasRoles || hasAnyPermission(pws)),
  )

  const hasAnyAllowedPermission = (
    permissionsWithScope: PermissionsWithScope | undefined,
    allowed?: string[],
  ) => {
    if (!allowed || allowed.length === 0) {
      return true
    }
    return allowed.some(name => hasPermission(permissionsWithScope, name))
  }

  if (!isAuthorizedSession) {
    return <Navigate to={`/login?from=${encodeURIComponent(location.pathname + location.search)}`} replace />
  }

  const needPerms = Boolean(allowedPermissions?.length)
  const accessOk = !needPerms || hasAnyAllowedPermission(pws, allowedPermissions)

  if (!accessOk) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
